import React from 'react';
import { getConstantStringByLanguage } from '../templates/helper/getConstantStringByLanguage';
import ConstantStrings from '../constants/ConstantStrings';
import PrimaryButtonPageLevel from './button/primary-button/PrimaryButtonLevelPage';
import BackgroundImageFromUrl from './parseImage/BackgroundImageFromUrl';
import { useNavigate } from 'react-router-dom';

const UpgradeAccountMessage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div
        className='is-flex is-align-items-center is-justify-content-center pb-4'
        style={{
          opacity: 1,
          zIndex: 1000,
          width: '100%',
          height: '100%',
        }}
      >
        <BackgroundImageFromUrl
          objectId='admin/frontend-images/auth/background-popup-upgrade-acc.svg'
          className='is-relative '
          style={{
            width: '34.125rem',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            height: '20.475rem',
            borderRadius: '2.5rem',
            position: 'relative',
          }}
        >
          <div
            style={{
              width: '13.5375rem',
              height: '14.4rem',
              position: 'absolute',
              top: '2.436rem',
              left: '4.5rem',
            }}
          >
            <div
              className='is-relative has-background-kurio-main-color-white is-flex is-flex-direction-column is-flex-gap-3 is-align-items-center'
              style={{
                borderRadius: '2.5rem',
                padding: '2.5rem 2.5rem 3rem 2.5rem',
                width: '13.5375rem',
                height: '14.4rem',
                boxShadow: '0.125rem 0.25rem 0rem 0rem #0A2A66',
                outline: '0.09375rem solid #0A2A66',
              }}
            >
              <div
                style={{
                  width: '3rem',
                  height: '3rem',
                  position: 'absolute',
                  top: '4.71rem',
                  left: '-0.9rem',
                }}
              >
                <img src='/images/auth/star-popup-upgrade-acc.svg' alt='' />
              </div>
              <div
                style={{
                  width: '3rem',
                  height: '3rem',
                  position: 'absolute',
                  top: '2.31rem',
                  right: '-0.875rem',
                }}
              >
                <img src='/images/auth/star-popup-upgrade-acc.svg' alt='' />
              </div>
              <div
                className='is-flex is-flex-direction-column is-flex-gap-2 has-text-weight-medium has-text-centered is-align-items-center is-justify-content-center'
                style={{
                  fontFamily: 'Dela Gothic One',
                }}
              >
                <p
                  className='has-text-kurio-main-color-black'
                  style={{
                    fontSize: '0.75rem',
                    width: '7.65rem',
                    lineHeight: '110%',
                  }}
                >
                  {getConstantStringByLanguage(
                    ConstantStrings.EXCLUSIVE_FEATURE
                  )}
                </p>
                <p
                  className=' has-text-kurio-yellow-dark'
                  style={{ fontSize: '1.5rem', lineHeight: '110%' }}
                >
                  {getConstantStringByLanguage(ConstantStrings.VIP_ACCOUNT)}
                </p>
              </div>
              <div
                className='has-text-kurio-main-color-black has-text-centered'
                style={{
                  fontSize: '0.83475rem',
                  lineHeight: 'normal',
                  fontStyle: 'normal',
                  width: '10.92rem',
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.UPGRADE_ACCOUNT)}
              </div>
              <div
                style={{
                  position: 'absolute',
                  bottom: '-1.5rem',
                }}
              >
                <PrimaryButtonPageLevel
                  onClick={() => {
                    navigate("/upgrade");
                  }}
                  style={{
                    width: '12rem',
                    height: '3.2rem',
                    maxWidth: '12rem',
                    borderRadius: '0.75rem',
                    fontSize: '0.83475rem',
                  }}
                >
                  {getConstantStringByLanguage(
                    ConstantStrings.GO_TO_UPGRADE_PAGE
                  )}
                </PrimaryButtonPageLevel>
              </div>
            </div>
          </div>
          <div
            style={{
              width: '11.1rem',
              height: '17.1rem',
              position: 'absolute',
              bottom: '0.0625rem',
              right: '2.75rem',
            }}
          >
            <img src='/images/auth/cu-quan.svg' alt='' />
          </div>
        </BackgroundImageFromUrl>
      </div>
    </div>
  );
};

export default UpgradeAccountMessage;
